import Model, { attr } from "@ember-data/model";
import type VitalSignItem from "./vital-sign/vital-sign-item";

export default class ConfigurationVitalSignModel extends Model {
  @attr("vital-sign-items") declare vitalSigns: Array<VitalSignItem>;
}

// DO NOT DELETE: thimport Helper from "@ember/component/helper";
// import { service } from '@ember/service';
// import Patient from "core/models/patient";
// import ConfigurationService, {
//   Configuration,
//   ConfigurationRegistry
// } from "core/services/configuration";
//
// /**
//  * A helper for accessing a patient's configuration from templates.
//  */
// export default class PatientConfigurationHelper extends Helper {
//   @service declare configuration: ConfigurationService;
//
//   compute([patient, configurationKey]: [
//     Patient,
//     Configuration
//   ]): ConfigurationRegistry[Configuration] {
//     return this.configuration.configurationForPatient(
//       configurationKey,
//       patient
//     );
//   }
// }is is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "configuration-vital-sign": ConfigurationVitalSignModel;
  }
}
